import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      const raw = localStorage.getItem("sdf_user");
      return raw ? JSON.parse(raw) : null;
    } catch { return null; }
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("sdf_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => { setUser(r.data); localStorage.setItem("sdf_user", JSON.stringify(r.data)); })
      .catch(() => { setUser(null); localStorage.removeItem("sdf_token"); localStorage.removeItem("sdf_user"); })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("sdf_token", data.token);
    localStorage.setItem("sdf_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const loginWithToken = (token, u) => {
    localStorage.setItem("sdf_token", token);
    localStorage.setItem("sdf_user", JSON.stringify(u));
    setUser(u);
    return u;
  };

  const logout = () => {
    // Best-effort backend session revocation — never block the redirect.
    api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("sdf_token");
    localStorage.removeItem("sdf_user");
    setUser(null);
    window.location.href = "/login";
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, loginWithToken, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
